import React, { FC } from "react";
import { useMedia } from "react-use";

import { MEDIA_SIZE_SM } from "@/core/media";

import { ISectionProps, Section } from "./Section";

interface ICardSectionProps extends Omit<ISectionProps, "borderRadius" | "shadow"> {}

export const CardSection: FC<ICardSectionProps> = ({ children, ...restProps }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <Section borderRadius={!isSmallScreen} shadow={isSmallScreen ? "none" : "default"} {...restProps}>
      {children}
    </Section>
  );
};
